import { Eyebrow } from './atoms'
import { resolveImageUrl } from '../lib/api'
import type { GalleryImage } from '../lib/types'

export function Gallery({ images }: { images: GalleryImage[] }) {
  if (!images.length) return null
  const cols = Math.min(3, images.length)
  return (
    <section style={{ background: 'var(--ink)', color: 'var(--fg-inverse)' }}>
      <div className="ax-grid-gallery" style={{
        display: 'grid',
        gridTemplateColumns: cols === 3 ? '1.2fr 1fr 1fr' : `repeat(${cols}, 1fr)`,
        gap: 2, background: 'var(--ink)',
      }}>
        {images.slice(0, 3).map((img) => (
          <img key={img.id}
               src={resolveImageUrl(img.image_key)}
               alt={img.alt ?? ''}
               style={{ width: '100%', height: 520, objectFit: 'cover', display: 'block' }} />
        ))}
      </div>
      <div className="ax-gallery-foot" style={{
        padding: '48px', maxWidth: 1280, margin: '0 auto',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderTop: '1px solid var(--line-inverse)',
      }}>
        <Eyebrow light>Live</Eyebrow>
        <div className="ax-gallery-hand" style={{ fontFamily: 'var(--font-script)', fontSize: 26, color: 'var(--fg-inverse)' }}>
          foto di chi c'era
        </div>
      </div>
    </section>
  )
}
